import { useContext, useEffect } from 'react';
import { uiContext } from '../contexts/UIContext';

const usePhatHeader = (enabled: boolean) => {
  const { setShowPhatHeader } = useContext(uiContext);
  useEffect(() => {
    setShowPhatHeader(enabled);
    return () => {
      setShowPhatHeader(false); // return to default
    };
  }, [enabled, setShowPhatHeader]);
};

export default usePhatHeader;
